import { printProfileSchema } from "@redotech/redo-fulfillment-outbound-labels-common/print-settings";
import * as z from "zod";

export const listPrintProfiles = {
  name: "listPrintProfiles" as const,
  input: z.object({}),
  output: z.object({ printProfiles: z.array(printProfileSchema) }),
};
